<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [areaName]="areaName"
  [label]="label"
  [model]="model"
  [noSubmit]="true"
  [showCloseBtn]="false"
  [isShowModal]="false"
  (cancelChange)="cancel()"
  [columns]="columns"
  (submitChange)="save()"
  (valueChange)="onFormChanges($event)">
  <ng-container class="content">
    <kgrid
      [apiName]="apiName"
      [noAutoFitColumns]="true"
      [columns]="gridColumns"
      [paging]="true"
      [areaName]="areaName"
      [label]="label"
      [name]="apiName"
      [reportName]="reportName"
      [pathPreFix]="pathPreFix"
      [isMulti]="true"
      [filters]="filters">
    </kgrid>
  </ng-container>
</dynamic-form>
